import { CSSProperties, Dispatch, ReactNode, SetStateAction } from 'react';
import { Options as RRuleOptions } from 'rrule';
import { DateField } from '@shared/data/entity/fields/DateField';
import { EntityBatchField } from '@shared/data/entity/fields/EntityBatchField';
import { Batch } from '@shared/scenes/cards/entityBulkActions/BatchCreateContext';
import { API } from '@shared/types/api';

export interface DateProps {
  field: DateField | null;
  component: API.DateComponent | API.RelatedCardLookupComponent;
  updateField?(componentId: string, field: DateField | null): void;
  workflowTemplateId: string;
  entityBatchField?: EntityBatchField;
  error?: string;
  includeWrapperPadding?: boolean;
  allowClear?: boolean;
  showIcon?: boolean;
  label?: string;
  showLabel?: boolean;
  reserveIconSpace?: boolean;
  compactTop?: boolean;
  compactBottom?: boolean;
  subfooter?: ReactNode;
  isGrayScale?: boolean;
  isItalic?: boolean;
  style?: CSSProperties;
}

export type BatchScheduleComponentProps = {
  date?: string;
  until?: Date;
  setUntil?: Dispatch<SetStateAction<Date | undefined>>;
  repeatEndType: RepeatEndType;
  setRepeatEndType: Dispatch<SetStateAction<RepeatEndType>>;
  showingCustomOptions: boolean;
  setShowingCustomOptions?: Dispatch<SetStateAction<boolean>>;
  showingTagFilterOptions?: boolean;
  setShowingTagFilterOptions?: Dispatch<SetStateAction<boolean>>;
  count: number | undefined;
  setCount?: Dispatch<SetStateAction<number | undefined>>;
  presets: Partial<RRuleOptions>[];
  filteredPresets: Partial<RRuleOptions>[];
  presetIndexSelected: number;
  setPresetIndexSelected: Dispatch<SetStateAction<number>>;
  isCustomSelected: boolean;
  isOffsetSelected: boolean;
  setUserIsEditing: Dispatch<SetStateAction<boolean>>;
  minimumInSeries?: number;
  setMinimumInSeries: Dispatch<SetStateAction<number | undefined>>;
  tagFilter?: API.FilterByComponentFragment;
  setTagFilter: Dispatch<SetStateAction<API.FilterByComponentFragment | undefined>>;
  component: API.DateComponent;
  workflowTemplateId: string;
} & Pick<
  Batch,
  | 'rruleOptions'
  | 'setRruleOptions'
  | 'offset'
  | 'setOffset'
  | 'recurrenceType'
  | 'setRecurrenceType'
>;

export enum RepeatEndType {
  COUNT = 'count',
  END_DATE = 'endDate',
  NEVER = 'never',
}

export type AutoExtendConditionType = 'default' | 'custom' | undefined;
export interface AutoExtendOptionsProps {
  minimumInSeries?: number;
  setMinimumInSeries: Dispatch<SetStateAction<number | undefined>>;
  tagFilter?: API.FilterByComponentFragment;
  setTagFilter: Dispatch<SetStateAction<API.FilterByComponentFragment | undefined>>;
  component: API.DateComponent;
  workflowTemplateId: string;
  showingTagFilterOptions?: boolean;
  setShowingTagFilterOptions?: Dispatch<SetStateAction<boolean>>;
  conditionType?: AutoExtendConditionType;
  setConditionType: Dispatch<SetStateAction<AutoExtendConditionType>>;
  setRepeatEndType: Dispatch<SetStateAction<RepeatEndType>>;
}
